import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useDeleteKeyFactsMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ keyFactKind }: { keyFactKind: Api.KeyDateKind }) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResult<Api.IOperationResultNoValue>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Contact/KeyFact?keyFactKind=${keyFactKind}`,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess,
	});
};
